export default "__VITE_ASSET__BsSlOwnT__"